<template>
  <div class="add-service">
    <div class="form-content">
      <el-form>
        <el-row>
          <el-col :span="12">
            <el-form-item label="语言" required>
              <el-select v-model="currentData.language_code" placeholder="请选择语言">
                <el-option v-for="item in languageList" :key="item.code" :label="item.name" :value="item.code" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="首页展示">
              <el-switch
                v-model="currentData.is_home"
                :active-value="1"
                :inactive-value="0"
                active-color="#409EFF"
                inactive-color="#dcdfe6"
              />
              <span style="margin-left: 10px; font-size: 12px; color: #909399;">
                （最多展示 3 条）
              </span>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 标题 -->
        <el-form-item label="标题" required>
          <el-input v-model="currentData.title" placeholder="请输入制造服务标题" />
        </el-form-item>

        <!-- 副标题 -->
        <el-form-item label="副标题">
          <el-input v-model="currentData.sub_title" placeholder="请输入副标题（选填）" />
        </el-form-item>

        <!-- 排序 -->
        <el-form-item label="排序">
          <el-input-number v-model="currentData.sort" :min="0" :max="9999" controls-position="right" />
          <span style="margin-left: 10px; font-size: 12px; color: #909399;">数值越小越靠前</span>
        </el-form-item>

        <!-- 图片 -->
        <el-form-item label="图片">
          <div class="upload-container">
            <upload
              :path="'service'"
              :images="currentData.image"
              :multiple="false"
              :num="1"
              @success="handleImageSuccess"
              @remove="handleImageRemove"
            />
          </div>
        </el-form-item>

        <!-- 内容 -->
        <el-form-item label="内容">
          <div class="content-mode-switch">
            <el-radio-group v-model="contentMode" size="small">
              <el-radio-button label="text">文字模式</el-radio-button>
              <el-radio-button label="list">列表模式</el-radio-button>
            </el-radio-group>
          </div>
          <!-- 文字模式：富文本编辑器 -->
          <div v-if="contentMode === 'text'" class="rich-text-editor-container">
            <rich-text-editor
              v-model="currentData.content"
              :path="'service'"
              :placeholder="placeholders[currentData.language_code] || '请输入内容'"
              @change="handleContentChange"
            />
          </div>
          <!-- 列表模式：动态添加条目 -->
          <div v-else class="content-list-editor">
            <div v-for="(item, index) in contentList" :key="index" class="content-list-row">
              <el-input
                v-model="contentList[index]"
                placeholder="请输入列表项内容"
                class="content-list-input"
              >
                <template slot="append">
                  <el-button
                    icon="el-icon-delete"
                    @click="removeContentItem(index)"
                  ></el-button>
                </template>
              </el-input>
            </div>
            <el-button
              type="primary"
              plain
              size="small"
              icon="el-icon-plus"
              @click="addContentItem"
              style="margin-top: 10px;"
            >
              添加列表项
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表单操作 -->
    <div class="form-actions">
      <el-button @click="$emit('cancel')">取消</el-button>
      <el-button type="primary" @click="handleSubmit">保存</el-button>
    </div>
  </div>
</template>

<script>
import { getLanguage } from '@/api/public'
import RichTextEditor from '@/components/tool/RichTextEditor'
import Upload from '@/components/tool/lib/upload/index.vue'
import { addService, updateService } from '@/api/website'

export default {
  name: 'AddService',
  components: {
    RichTextEditor,
    Upload
  },
  props: {
    service: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      languageList: [],
      contentMode: 'text', // 'text' 文字模式 | 'list' 列表模式
      contentList: [], // 列表模式数据
      currentData: {
        language_code: 'zh',
        title: '',
        sub_title: '',
        image: '',
        content: '',
        is_home: 0,
        sort: 0
      },
      placeholders: {
        zh: '请输入制造服务内容',
        en: 'Please enter service content',
        ko: '서비스 내용을 입력하세요'
      }
    }
  },
  watch: {
    service: {
      handler(newService) {
        if (newService) {
          this.resetForm()
          this.currentData = {
            id: newService.id,
            language_code: newService.language_code || 'zh',
            title: newService.title || '',
            sub_title: newService.sub_title || '',
            image: newService.image || '',
            content: newService.content || '',
            is_home: newService.is_home || 0,
            sort: newService.sort || 0
          }
          // 根据已有内容自动判断模式
          this.detectContentMode(newService.content || '')
        } else {
          this.resetForm()
        }
      },
      immediate: true
    }
  },
  mounted() {
    this.getLanguageList()
  },
  methods: {
    async getLanguageList() {
      try {
        const res = await getLanguage()
        this.languageList = res.data || []
      } catch (error) {
        console.error('获取语言列表失败:', error)
      }
    },
    resetForm() {
      this.contentMode = 'text'
      this.contentList = []
      this.currentData = {
        language_code: 'zh',
        title: '',
        sub_title: '',
        image: '',
        content: '',
        is_home: 0,
        sort: 0
      }
    },
    handleImageSuccess(images) {
      this.currentData.image = images[0]
    },
    handleImageRemove(images) {
      this.currentData.image = images.length > 0 ? images[0] : ''
    },
    handleContentChange(content) {
      this.currentData.content = content
    },
    // 自动检测内容模式
    detectContentMode(content) {
      if (!content) {
        this.contentMode = 'text'
        this.contentList = []
        return
      }
      try {
        var parsed = JSON.parse(content)
        if (Array.isArray(parsed)) {
          this.contentMode = 'list'
          this.contentList = parsed.map(function(item) {
            return item.text || ''
          })
        } else {
          this.contentMode = 'text'
          this.contentList = []
        }
      } catch (e) {
        this.contentMode = 'text'
        this.contentList = []
      }
    },
    // 列表模式：添加条目
    addContentItem() {
      this.contentList.push('')
    },
    // 列表模式：删除条目
    removeContentItem(index) {
      this.contentList.splice(index, 1)
    },
    handleSubmit() {
      if (!this.currentData.language_code) {
        this.$message.error('请选择语言')
        return
      }
      if (!this.currentData.title) {
        this.$message.error('请输入标题')
        return
      }

      const submitData = { ...this.currentData }
      // 列表模式下将 contentList 序列化为 JSON
      if (this.contentMode === 'list') {
        submitData.content = JSON.stringify(
          this.contentList.filter(function(item) { return item.trim() !== '' }).map(function(item) {
            return { text: item }
          })
        )
      }
      const isEdit = submitData.id

      const apiCall = isEdit
        ? updateService(submitData.id, submitData)
        : addService(submitData)

      apiCall.then(res => {
        if (res.code === 200) {
          this.resetForm()
          this.$emit('save', true)
        } else {
          this.$message.error(res.msg || '保存失败')
        }
      }).catch(() => {
        this.$message.error('保存失败')
      })
    }
  }
}
</script>

<style scoped lang="scss">
.add-service {
  box-sizing: border-box;
  padding: 0 20px;
}

.form-content {
  box-sizing: border-box;
  margin-bottom: 30px;
}

.content-mode-switch {
  margin-bottom: 10px;
}

.content-list-editor {
  border: 1px solid #e4e7ed;
  border-radius: 8px;
  background-color: #f9f9f9;
  padding: 15px;
}

.content-list-row {
  margin-bottom: 10px;
}

.content-list-row:last-child {
  margin-bottom: 0;
}

.content-list-input {
  width: 100%;
}

.rich-text-editor-container {
  border: 1px solid #e4e7ed;
  background-color: #f9f9f9;
  padding: 10px;
  min-height: 300px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #f0f2f5;
}

/* 响应式 */
@media (max-width: 768px) {
  .add-service {
    padding: 10px 0;
  }

  .form-content {
    margin-bottom: 20px;
  }

  .rich-text-editor-container {
    min-height: 200px;
  }

  .form-actions {
    flex-direction: column;
  }

  .form-actions .el-button {
    width: 100%;
  }

  .quill-editor {
    height: 150px;
  }

  .ql-toolbar.ql-snow {
    flex-wrap: wrap;
  }

  .ql-toolbar.ql-snow .ql-formats {
    margin-right: 10px;
    margin-bottom: 5px;
  }
}
</style>
